module.exports = __webpack_public_path__ + "fonts/CenturyGothic-BoldItalic.c8db09a8.eot";